define(function(t,e){"use strict";function i(t,e){this.tempStrings={Current:"Current",New:"New",Update:"Office Phone"},this.cancel=function(){e.closePopup()},t.onLoadCall(),this.viewModel=t.viewModel,this.viewModel.otpError=!1,this.otpOfficeAuthControl=t.otpOfficeAuthControl}i.$inject=["otpService","NavigationService"],e.otpCtrl=i});


// WEBPACK FOOTER //
// ./src/widget-hdfc-rbi-bond/scripts/otpCtrl.js